<script lang="ts" setup>
import {AssetInterface} from "@/js/interfaces/asset"
import {useTracking} from "@/js/composables/plausible"
import {computed} from "vue"
import BannerCarousel from "@/js/components/marketing/asset/BannerCarousel.vue"

const props = withDefaults(defineProps<{
	assets: AssetInterface[]
	effect?: 'fade' | 'slide'
	interval?: number
	transitionDuration?: number
	noUpscale?: boolean
}>(), {
	effect: 'slide',
	interval: 5000,
	transitionDuration: 800,
	noUpscale: false,
})

const tracking = useTracking()

const sortedAssets = computed(() =>
		[...props.assets].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
)

const trackClick = (asset: AssetInterface) => {
	const currentPagePath = window.location.pathname
	const assetUrlPath = new URL(asset.destination_url).pathname
	tracking.campaignClick('Asset Banner', assetUrlPath + ', clicked on ' + currentPagePath)
}
</script>

<template>
	<BannerCarousel
			:effect="effect"
			:interval="interval"
			:items="sortedAssets"
			:transition-duration="transitionDuration"
	>
		<template #default="{ item }">
			<a :href="item.destination_url" @click="trackClick(item)">
				<img :src="item.path" :style="noUpscale
				         ? 'display:block; max-width:100%; width:auto; height:auto; margin:0 auto'
				         : 'display:block; width:100%'" :title="item.destination_url"
				     draggable="false"
				/>
			</a>
		</template>
	</BannerCarousel>
</template>
